import { Stack, TextField, Typography } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useState } from "react";
import { luxonFormats, luxonViews } from "../../blockTypes";

type Props = {
  currentBlock: any;
};

const InitialsFieldPreview = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;
  const position = currentBlock?.config?.position;
  const isMultiline = currentBlock?.config?.allowMultiline;
  const type = currentBlock?.config?.type;
  const format = currentBlock?.config?.format;
  const optional = currentBlock?.config?.optional;
  const [tempDate, setTempDate] = useState(null);

  return (
    <Stack gap={1} direction={position === "top" ? "column-reverse" : "column"}>
      <Typography variant="subtitle1" fontWeight="regular">
        {label}
        {!optional && <span style={{ color: "red" }}>*</span>}
      </Typography>
      {type === "text" && (
        <TextField
          name="label"
          fullWidth
          multiline={isMultiline}
          rows={isMultiline ? 3 : 1}
          placeholder="Enter value"
        />
      )}
      {type === "date" && (
        <DateTimePicker
          format={luxonFormats?.[format]}
          value={tempDate}
          views={luxonViews?.[format]}
          onChange={(newDate) => setTempDate(newDate)}
          slotProps={{
            textField: {
              fullWidth: true,
              InputProps: {
                readOnly: true,
                placeholder: format,
              },
            },
            field: {
              readOnly: true,
            },
          }}
          timeSteps={{
            minutes: 1,
            seconds: 1,
          }}
        />
      )}
    </Stack>
  );
};
export default InitialsFieldPreview;
